import OptionBlock from "../optionBlock";
import i18nPackage from "../../../i18n/i18n";
import { CheckBoxMenuSubItem } from "../option-menus/checkBoxMenuSubItem";
import { useProctoringOptionContext } from "../../context/EditQuizContext";
import { useProctoringHelpers } from "../hooks/useProctoringHelpers";
import { Trans } from "react-i18next";

function SignatureOption() {
	const { proctoringOption, setProctoringOption } = useProctoringOptionContext();

	const { uploadSignature } = proctoringOption;

	return (
		<OptionBlock
			optionKey="uploadSignature"
			checked={Boolean(uploadSignature)}
			updateState={(checked) =>
				setProctoringOption({
					...proctoringOption,
					uploadSignature: checked,
				})
			}
		/>
	);
}

function IdVerificationOption() {
	const { proctoringOption, setProctoringOption } = useProctoringOptionContext();
	const { isOptionAllowed, getPartiallySupportedPlatforms } = useProctoringHelpers();

	const { idVerification, idVerificationEnableAi, idVerificationMode } = proctoringOption;

	const menuItems = isOptionAllowed("idVerificationEnableAi") ? (
		<>
			<CheckBoxMenuSubItem
				label={
					<Trans
						i18n={i18nPackage}
						i18nKey={"editQuizPage.configurationStep.verifyIdentityTSX.idVerificationEnableAi.label"}
						components={{ b: <strong /> }}
					/>
				}
				checked={idVerificationEnableAi || false}
				onChange={(checked) => {
					setProctoringOption({
						...proctoringOption,
						idVerificationEnableAi: checked,
						idVerificationMode: checked ? "normal" : "off",
					});
				}}
				partiallySupportedPlatforms={getPartiallySupportedPlatforms("idVerificationEnableAi")}
			>
				{isOptionAllowed("idVerificationMode", "normal") &&
					isOptionAllowed("idVerificationMode", "strict") &&
					idVerificationEnableAi && (
						<CheckBoxMenuSubItem
							label={i18nPackage.t("editQuizPage.configurationStep.verifyIdentityTSX.idVerificationEnableAi.bypass")}
							checked={idVerificationMode === "normal"}
							onChange={(checked) => {
								setProctoringOption({
									...proctoringOption,
									idVerificationMode: checked ? "normal" : "strict",
								});
							}}
						/>
					)}
			</CheckBoxMenuSubItem>
		</>
	) : null;

	return (
		<OptionBlock
			optionKey="idVerification"
			checked={Boolean(idVerification)}
			updateState={(checked) =>
				setProctoringOption({
					...proctoringOption,
					idVerification: checked,
					idVerificationEnableAi: false,
					idVerificationMode: "off",
				})
			}
			{...(menuItems ? { menuItems } : {})}
		/>
	);
}

export default function VerificationOptions() {
	const { shouldShowOption } = useProctoringHelpers();
	return (
		<>
			{shouldShowOption("idVerification") && <IdVerificationOption />}
			{shouldShowOption("uploadSignature") && <SignatureOption />}
		</>
	);
}
